import langEnLocale from "@karaokemugen/i18n-iso-languages/langs/en.json";
import langFrLocale from "@karaokemugen/i18n-iso-languages/langs/fr.json";
import languages from '@karaokemugen/i18n-iso-languages';
import { useTranslationLang } from "@bsm/component";

languages.registerLocale(langEnLocale);
languages.registerLocale(langFrLocale);

const langNamesEn = languages.getNames("en");
const langNamesFr = languages.getNames("fr");

export const formatLanguage = (codes: string | null | undefined): string => {
  if (!codes) return '-';
  const { lang } = useTranslationLang()
  const names = lang === 'fr' ? langNamesFr : langNamesEn;
  return codes.split(',').map(code => names[code.trim()] || code.trim()).join(', ');
};
